<template>
  <div class="edit-sts">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Серия</label>
        <input
          v-model="data.series"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </div>
      <div class="col-md-4 mb-2">
        <label>Номер</label>
        <input
          v-model="data.number"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Дата выдачи</label>
        <input
          v-model="data.issue_date"
          type="date"
          class="form-control"
          placeholder
          required
        >
      </div>
    </div>
  </div>
</template>

<script>
const type = 'sts'

export default {
  name: 'DocumentStsEdit',
  props: {
    documentData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      data: {
        series: '',
        number: '',
        issue_date: ''
      }
    }
  },
  watch: {
    data: {
      handler () {
        this.update()
      },
      deep: true
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
    this.update()
  },
  methods: {
    update () {
      this.$emit('update', {
        type: type,
        data: this.data
      })
    }
  }
}
</script>

<style scoped>
  .edit-sts input {
    margin-bottom: 5px;
  }
  .edit-sts textarea {
    margin-bottom: 5px;
  }
</style>
